import { Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "stores/authStore";

interface OfflineBarProps {}

const OfflineBar: React.FC<OfflineBarProps> = ({}) => {
  const { t } = useTranslation("common");
  const isOffline = useAuthStore(state => state.isOffline);

  if (isOffline) {
    return (
      <Text
        size="sm"
        className="flex z-0 fixed bottom-0 left-0 right-0 justify-center bg-yellow border-t border-gray"
      >
        {t("offline").toUpperCase()}
      </Text>
    );
  }

  return null;
};

export default OfflineBar;
